
import React from 'react';

interface AboutContentProps {
  isVisible: boolean;
}

const AboutContent = ({ isVisible }: AboutContentProps) => {
  return (
    <div className="prose prose-invert prose-lg max-w-none flex-1">
      <p className={`transition-all duration-500 delay-[200ms] mb-4 ${isVisible ? 'opacity-100 translate-x-0 slide-right' : 'opacity-0 -translate-x-8'
        }`}>
        Over the last five years as a Frontend Engineer, I've worked heavily in React and TypeScript to build applications that solve real problems. My work primarily involves taking complicated domain logic, like healthcare workflows or financial data, and turning it into interfaces that make sense to the user.
      </p>
      <p className={`transition-all duration-500 delay-[400ms] mb-4 ${isVisible ? 'opacity-100 translate-x-0 slide-right' : 'opacity-0 -translate-x-8'
        }`}>
        I care deeply about component architecture and accessibility. For me, a successful project isn't just about shipping features; it's about writing code that my team can easily maintain and that users can rely on without friction.
      </p>
      <p className={`transition-all duration-500 delay-[600ms] mb-4 ${isVisible ? 'opacity-100 translate-x-0 slide-right' : 'opacity-0 -translate-x-8'
        }`}>
        Recently, I've been exploring Agentic workflows, RAG, and LLM-powered applications using modern JavaScript tooling. It's a space I'm curious about, and I enjoy seeing how intelligent tools can integrate into standard frontend workflows.
      </p>
      <p className={`transition-all duration-500 delay-[800ms] mb-4 ${isVisible ? 'opacity-100 translate-x-0 slide-right' : 'opacity-0 -translate-x-8'
        }`}>
        Outside of the editor, I value clear communication and cross-functional collaboration. I believe the best engineering decisions happen when developers deeply understand the product they are building.
      </p>
    </div>
  );
};

export default AboutContent;
